export class Score {
	public clientCode : string;
	public answers = {};
	public wing = {right:0,left:0};
	public direction = {conservative:0,progressive:0};
	public parties = {};
	public politicalParties = {};
	
	addAnswer (key, questionType, answer) {
		this.answers[key] = answer;
		for (let i=0;i<answer.length;i++) {
			if (questionType === 'wing') {
				this.addWingAnswer(answer[i]);
			} else if (questionType === 'direction') {
				this.addDirectionAnswer(answer[i]);
			} else {
				this.addPoliticalAnswer(answer[i]);
			}
		}
	}
	
	setPoliticalParties (politicalParties) {
		this.politicalParties = politicalParties;
	}
	
	getPoliticalParties () {
		return this.politicalParties;
	}
	
	getClientCode () {
		return this.clientCode;
	}
	
	setClientCode (clientCode) {
		this.clientCode = clientCode;
	}
	
	getWing () {
		if (this.wing['left'] > this.wing['right']) {
			return 'left';
		} else {
			return 'right';
		}
	}
	
	getDirection () {
		if (this.direction['conservative'] > this.direction['progressive']) {
			return 'conservative';
		} else {
			return 'progressive';
		}
	}
	
	addWingAnswer (key) {
		if (typeof(this.wing[key]) === 'undefined') {
			this.wing[key] = 1;
		} else {
			this.wing[key]++;
		}
	}
	
	addDirectionAnswer (key) {
		if (typeof(this.direction[key]) === 'undefined') {
			this.direction[key] = 1;
		} else {
			this.direction[key]++;
		}
	}
	
	addPoliticalAnswer (party) {
		if (typeof(this.parties[party]) === 'undefined') {
			this.parties[party] = 1;
		} else {
			this.parties[party]++;
		}
	}
	
	getPoliticalIdeoligy () {
		return this.getWing() + '-' + this.getDirection();
	}
	
	getParties () {
		let partyScores = [];
		let party = null;
		for (let key in this.parties) {
			let score = (typeof(this.parties[key]) === 'undefined' ? 0 : this.parties[key]);

			if (typeof(partyScores[score]) === 'undefined') {
				partyScores[score] = [];
			}
		
			partyScores[score].push(key);
		}
		
		let partyList = JSON.parse(JSON.stringify(partyScores));
		let winners = partyList.pop();
		return winners;
	}
	
	getParty () {
		let partyScores = [];
		let party = null;
		for (let key in this.parties) {
			let score = (typeof(this.parties[key]) === 'undefined' ? 0 : this.parties[key]);

			if (typeof(partyScores[score]) === 'undefined') {
				partyScores[score] = [];
			}
		
			partyScores[score].push(key);
		}
		
		let partyList = JSON.parse(JSON.stringify(partyScores));
		
		let winners = partyList.pop();
			
		if (winners.length > 1) {
			party = winners[0]; // altijd een uitkomst, dan dus de bovenste
		} else {
			party = winners.pop();
		}
		
		return party;
	}
	
	getWingText () {
		if (this.getWing() === 'left') {
			return 'Links';
		} else {
			return 'Rechts';
		}
	}
	
	getDirectionText () {
		if (this.getDirection() === 'progressive') {
			return 'Progressief';
		} else {
			return 'Conservatief';
		}
	}
	
	getAnswers () {
		return this.answers;
	}
}
